if (typeof window !== 'undefined') {
  window.lastPlayFilename = '';
}

function playBallNumber (ballName) {
  try {
    if (ballName === '') return;

    var audioConfig = getAudioConfiguration();
    if (audioConfig === 'off') return;
    var y = document.getElementById('audioActive');
    y.src = '/Audio/F/'.concat(ballName, '.mp3?v2');
    y.play();
  } catch (err) {
    console.error(err);
  }
}

function playFile (filename) {
  try {
    const f = filename.includes('/Audio/F/')
      ? filename
      : ('/Audio/F/'.concat(filename, '.mp3?v3'));
    return f;
  } catch (err) {
    console.error(err);
  }
}

function playNext (filenames) {
  var files = filenames.split(',');
  var filename = files[0];
  window.audioFilenames = filenames.substring(filenames.indexOf(',') + 1);
  playFile(filename);
}

function getAudioConfiguration () {
  if (typeof window.audioConfiguration === 'undefined') {
    window.audioConfiguration = 'off';
  }

  return window.audioConfiguration;
}

function setAudio (status) {
  if (status === 'off') {
    /* eslint-disable */
    $('#audioOff').removeClass('btn btn-light');
    $('#audioOn').addClass('btn btn-light');
    window.audioConfiguration = 'off';
  } else {
    $('#audioOn').removeClass('btn btn-light');
    $('#audioOff').addClass('btn btn-light');
    $('#divAudio').show();
    window.audioConfiguration = 'F';
  }
}

export { getAudioConfiguration, playBallNumber, playFile, playNext, setAudio };

